var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extra-large":"","hide-footer":"","title":"Agendamento de exame"}},[_c('List',{attrs:{"is-modal":""},on:{"create":_vm.create}}),(_vm.id)?_c('Modal',{ref:"Modal",attrs:{"paciente-id":_vm.id,"hasAmbulatorio":true},on:{"save":_vm.handleSave}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }